<script>
export default {
    name: "Status",
    props: ['status'],
    computed: {
        classStatus() {
            if (this.status === 'Новая') {
                return 'new';
            } else if (this.status === 'В работе') {
                return 'in_work';
            } else if (this.status === 'Закрыта') {
                return 'incorrect_data';
            }
        }
    }
}
</script>

<template>
    <div><span :class="{
        badge: true,
        [`badge-request-status-${classStatus}`]: true
    }">{{status}}</span></div>
</template>

<style scoped>

</style>